import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { Paper, Tooltip, IconButton } from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';
import useListFilter from '../../np-components/Datatable/listFilter';
import NPDatatable from '../../np-components/Datatable';
import { hasPermission, hasAtLeastOnePermission } from '../../sc-utilities';

const styles = theme => ({
    userActive: {
        color: theme.palette.success.dark,
        marginTop: 8.5,
        fontSize: 15
    },
    userInactive: {
        color: theme.palette.error.dark,
        padding: 1,
        margin: 1,
        fontSize: 15
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    }
});

const VehicleList = props => {
    const { classes, vehicles, fetchVehicles, columnsState, activeCustomer, permissions } = props;
    const vehicleCount = vehicles.count;
    const vehicleList = vehicles.list;
    let tableID = 'Vehicle';
    let visible = columnsState && columnsState[tableID];

    const columns = [
        {
            displayName: 'Actions',
            backendName: 'Action',
            options: {
                align: 'left',
                sortable: false,
                searchable: false,
                visible: visible ? visible['Action'] : true,
            }
        },
        {
            displayName: 'Name',
            backendName: 'Name',
            options: {
                align: 'left',
                sortable: true,
                searchable: true,
                visible: visible ? visible['Name'] : true,
            }
        },
        {
            displayName: 'License number',
            backendName: 'LicenseNumber',
            options: {
                align: 'left',
                sortable: true,
                searchable: true,
                visible: visible ? visible['LicenseNumber'] : true,
            }
        },
        {
            displayName: 'Payload',
            backendName: 'Payload',
            options: {
                align: 'left',
                sortable: true,
                searchable: true,
                visible: visible ? visible['Payload'] : true,
            }
        }
    ];

    let backendNames = [];
    columns.map(column => { if (column.backendName !== 'Action') backendNames.push(column.backendName); return null; })
    const listFilter = useListFilter({ rowsPerPage: 20, searchColumns: backendNames });
    if (!hasAtLeastOnePermission(permissions, ['vehicle_load', 'vehicle_delete'])) {
        columns.splice(0, 1);
    }
    const createActions = (vehicleID) => {
        return <>
            {
                hasPermission(permissions, 'vehice_load') ?
                    <Tooltip title="Edit vehicle ">
                        <IconButton value={vehicleID} onClick={props.handleEdit} aria-label="Edit vehicle"  >
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    : null
            }
            {
                hasPermission(permissions, 'vehicle_delete') ?

                    <Tooltip title="Delete vehicle ">
                        <IconButton value={vehicleID} aria-label="Delete vehicle" onClick={props.handleDelete} >
                            <Delete />
                        </IconButton>
                    </Tooltip>
                    : null
            }
        </>
    };

    useEffect(() => {
        // fetch calls
        if (listFilter.filter) {
            fetchVehicles({ ...listFilter.filter, ActiveCustomerID: activeCustomer });
        }
    }, [vehicles.created, vehicles.deleted, vehicles.bulkDeleted, activeCustomer, vehicles.edited, fetchVehicles, listFilter.filter]);
    const tableOptions = {
        isSelectable: false,
        tableSearch: true,
        tableID: tableID,
        saveColumn: true,
        page: 0,
        selectOptions: { printing: false, generatingReport: false, creating: hasPermission(permissions, 'vehicle_create') ? true : false, deleting: false },
        rowsPerPage: 20,
        count: vehicleCount,
        rowsPerPageOptions: [20, 10, 20, 50, 75, 100, 'All'],
        tableTitle: 'Vehicles',
        noMatch: "Sorry, no matching records found",
        onTableChange: listFilter.onTableChange,
        onSaveFilter: (columns) => {
            let objToSendColumn = {}
            let objColumns = {}
            columns.map(column => {
                objColumns[`${column.backendName}`] = column.options.visible
                return objColumns
            })
            objToSendColumn[`${tableID}`] = objColumns
            props.saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        }

    };



    let counter = 0;
    let vehicleData = vehicleList.map(vehicle => {
        let returnObj = {};
        returnObj.index = counter;
        returnObj.selected = false;
        returnObj.id = vehicle.VehicleID
        returnObj.visible = true;
        returnObj.values = [
            createActions(vehicle.VehicleID),
            vehicle.Name,
            vehicle.LicenseNumber,
            vehicle.Payload
        ];
        if (!hasAtLeastOnePermission(permissions, ['vehicle_load', 'vehicle_delete'])) {
            returnObj.values.splice(0, 1);
        }
        counter++;
        return returnObj;
    });

    return (
        <Paper>
            <NPDatatable handleCreate={props.handleCreate} customStyles={classes} data={vehicleData} columns={columns} options={tableOptions} />
        </Paper>
    );
}

export default (withStyles(styles)(VehicleList));